import React, { useEffect, useState } from "react";
import { BackButton } from "../../components/btn/Buttons";
import PageHeading from "../../components/PageHeading";
import { Input } from "../../components/inputs/Inputs";
import Button from "../../components/btn/Button";
import { useSelector } from "react-redux";
import Table from "../../components/table/Table";
import store from "../../redux/store";
import { get_deleted_report_list } from "./DeletedReportSlice";
import moment from "moment";
import Loader from "../../components/Loader";
import { Pagination2 } from "../../components/pagination/pagination";
import NoData from "../../components/NoData";
import SmallModal from "../../components/modal/SmallModal";
import { downloadExcel, exportPDF } from "../../utils/utils";
import { Alerts } from "../../components/Alerts/Alerts";

const DeleteReport = () => {
  const [addData, setAddData] = useState({
    from_date: "",
    to_date: "",
  });
  const [addDataPre, setAddDataPre] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [mess, setMess] = useState("");
  const [totalCount, setTotalCount] = useState("50");
  const [entries, setEntries] = useState("10");
  const [pageNo, setPageNo] = useState(1);
  const [serchInput, setSerchInput] = useState("");
  const [showData, setShowData] = useState(false);
  const [deleted_report_item_list, setDeletedReportItemList] = useState([]);

  const { firm_name } = useSelector((state) => state.profile);
  const { user_id } = useSelector((state) => state.other);

  useEffect(() => {
    // Initialize with today's date
    const todayFormatted = moment().format("YYYY-MM-DD");
    setAddData({
      from_date: todayFormatted,
      to_date: todayFormatted,
    });
  }, []);

  useEffect(() => {
    if (showData) {
      get_list(addDataPre);
    }
  }, [pageNo, entries]);

  const table_header = [
    "Module Name",
    "Transaction Amount",
    "Transaction ID",
    "Transaction Date",
    "Party Name",
    "Created By",
    "Created Date",
    "Deleted By",
    "Deleted Date",
  ];

  const get_list = async (addData, data1 = "") => {
    const data = validate(addData);
    if (data?.length === 0) {
      try {
        setShowLoader(true);
        const body = new FormData();
        body.append("action", "list");
        body.append("agencyid", user_id);
        body.append("fd", addData?.from_date);
        body.append("td", addData?.to_date);
        body.append("page", data1?.length > 1 || data1 === "main" ? 1 : pageNo);
        body.append(
          "limit",
          data1?.length > 1
            ? data1 === "main"
              ? entries
              : totalCount
            : entries
        );

        const response = await fetch(
          "https://mylpgdev.metagas.in/api/reports/deleted_report.php",
          {
            method: "POST",
            body: body,
          }
        );
        const result = await response.json();
        setShowLoader(false);

        if (result.success) {
          if (data1 === "excel") {
            export_excel(addData, result?.data);
          } else if (data1 === "pdf") {
            export_pdf(addData, result?.data);
          } else {
            setDeletedReportItemList(result?.data || []);
            setTotalCount(result?.totalcount);
            setShowData(true);
            setAddDataPre(addData);
          }
        } else {
          setMess("No Data Found");
          setOpen(true);
        }
      } catch (error) {
        console.log(error);
        setMess("Error fetching deleted report");
        setOpen(true);
        setShowLoader(false);
      }
    } else {
      setMess(<Alerts data={data} />);
      setOpen(true);
    }
  };

  const validate = (addData) => {
    const data = [];
    if (!addData?.from_date || addData?.from_date?.length !== 10) {
      data.push("Please Enter From Date");
    }
    if (!addData?.to_date || addData?.to_date?.length !== 10) {
      data.push("Please Enter To Date");
    }
    return data;
  };

  const export_pdf = (addData, data) => {
    const exportData = data?.map((v, i) => [
      v?.SOURCE || "NA",
      v?.INVOICE_AMOUNT || "NA",
      v?.SR_NO || "NA",
      v?.SR_DATE || "NA",
      v?.PARTY_NAME || "NA",
      v?.CREATED_NAME || "NA",
      v?.CREATED_DATE || "NA",
      v?.DELETED_NAME || "NA",
      v?.DELETED_DATE || "NA",
    ]);
    console.log("exportData", exportData);

    exportPDF({
      table_data: exportData,
      table_headers: table_header,
      tableName: `${firm_name} - DELETED REPORT -- FROM DATE : ${moment(
        addData?.from_date
      ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
        "DD/MM/YY"
      )}`,
      fileName: firm_name,
    });
  };

  const export_excel = (addData, data) => {
    const exportData = data?.map((v, i) => [
      // v?.SOURCE || "NA",
      // v?.SR_NO || "NA",
      // v?.SR_DATE || "NA",
      // v?.DELETED_NAME || "NA",
      // v?.DELETED_DATE || "NA",
      v?.SOURCE || "NA",
      v?.INVOICE_AMOUNT || "NA",
      v?.SR_NO || "NA",
      v?.SR_DATE || "NA",
      v?.PARTY_NAME || "NA",
      v?.CREATED_NAME || "NA",
      v?.CREATED_DATE || "NA",
      v?.DELETED_NAME || "NA",
      v?.DELETED_DATE || "NA",
    ]);
    console.log("exportData===>", exportData);
    downloadExcel(
      exportData,
      table_header,
      `${firm_name} - DELETED REPORT -- FROM DATE : ${moment(
        addData?.from_date
      ).format("DD/MM/YY")} & TO DATE : ${moment(addData?.to_date).format(
        "DD/MM/YY"
      )}`
    );
  };

  return (
    <div className="container">
      <PageHeading title={"DELETED RECORDS LOGS"} right={<BackButton />} />

      <div className="transactionMain">
        <div style={{ width: "180px" }}>
          <Input
            label={"FROM DATE"}
            type={"date"}
            value={addData?.from_date}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                setAddData({ ...addData, from_date: e.target.value });
              }
            }}
          />
        </div>
        <div style={{ width: "180px" }}>
          <Input
            label={"TO DATE"}
            value={addData?.to_date}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                setAddData({ ...addData, to_date: e.target.value });
              }
            }}
            type={"date"}
          />
        </div>

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <Button
            title={"SEARCH"}
            onClick={async () => {
              await setShowData(false);
              await setPageNo(1);
              await setEntries(10);
              get_list(addData, "main");
            }}
          />
        </div>
      </div>

      {showData && deleted_report_item_list?.length > 0 ? (
        <>
          <div className="SFromDate">
            {/* <span style={{ fontSize: "11PX" }}>FROM DATE :</span>
            <p className="FDATE">
              {moment(addDataPre?.from_date).format("DD/MM/YY")}
            </p>
            <span style={{ fontSize: "11PX" }}>TO DATE :</span>
            <p className="FDATE">
              {moment(addDataPre?.to_date).format("DD/MM/YY")}
            </p>
            {/* <span style={{ fontSize: "11PX" }}>TOTAL RECORDS :</span> */}
            {/* <h6 className="PDS">{totalCount}</h6> */}
          </div>

          <Pagination2
            count={0}
            download={true}
            PDFDown={() => get_list(addDataPre, "pdf")}
            excelDown={() => get_list(addDataPre, "excel")}
            top={true}
            totalCount={totalCount}
            SerchInput={serchInput}
            setSearchInput={setSerchInput}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          />

          {deleted_report_item_list?.length === 0 ? (
            <NoData mt={30} />
          ) : (
            <Table
              headData={table_header}
              body={
                <>
                  {deleted_report_item_list?.map((v, i) => (
                    <tr key={i}>
                      <td>{v?.SOURCE || "NA"}</td>
                      <td>{v?.INVOICE_AMOUNT || "NA"}</td>
                      <td>{v?.SR_NO || "NA"}</td>
                      <td>{v?.SR_DATE || "NA"}</td>
                      <td>{v?.PARTY_NAME || "NA"}</td>
                      <td>{v?.CREATED_NAME || "NA"}</td>
                      <td>{v?.CREATED_DATE || "NA"}</td>
                      <td>{v?.DELETED_NAME || "NA"}</td>
                      <td>{v?.DELETED_DATE || "NA"}</td>
                    </tr>
                  ))}
                </>
              }
            />
          )}

          <Pagination2
            count={0}
            bottom={true}
            totalCount={totalCount}
            SerchInput={serchInput}
            setSearchInput={setSerchInput}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          />
        </>
      ) : showData ? (
        <NoData title={"NO RECORDS FOUND"} color="red" mt={30} />
      ) : (
        ""
      )}

      <div style={{ height: "10px" }}></div>

      {open && (
        <SmallModal
          isOpen={open}
          setIsOpen={setOpen}
          title={"Alerts"}
          mess={mess}
          okbtn={setOpen}
        />
      )}
      {showLoader && <Loader />}
    </div>
  );
};

export default DeleteReport;
